import React from 'react';
import { Redirect } from 'react-router-dom';
import { Container, Dimmer, Form, Icon, Loader } from 'semantic-ui-react';
import ImageOnS3 from '../../../components/imageOnS3/imageOnS3.component';
import { BannerModel } from '../../../entities/banner.model';
import { ImageModel } from '../../../entities/image.model';
import MyForm from './form';
import MyFormState from './MyFormState';

interface FormProps {
    match: any,
    history: any
}

class BannerForm extends MyForm<FormProps, MyFormState> {

    entity = "content";
    navigationEntity = "banner";

    constructor(props: any) {
        super(props);
        this.state = {
            model: new BannerModel,
            successMsg: "",
            errorMsg: "",
            loading: true,
            editing: false,
            editingSlug: false,
            slugValid: true,
            imageObj: ImageModel.empty(),
            imageObjs: { lg: ImageModel.empty(), sm: ImageModel.empty(), xs: ImageModel.empty(),
                image1: ImageModel.empty(), image2: ImageModel.empty(), image3: ImageModel.empty(),
                image4: ImageModel.empty(), image5: ImageModel.empty(), image6: ImageModel.empty()
            },
            redirect: "",
        }
    }

    componentWillMount() {
        let model: BannerModel = new BannerModel();
        this.setState({ model: model});
    }

    validate(): boolean {
        this.setState({ successMsg: "" });
        if (!this.state.model.name) {
            this.setState({ errorMsg: "Баннерийн нэрийг оруулна уу." });
            return false;
        }
        if (!this.state.model.type) {
            this.setState({ errorMsg: "Баннерийн төрөл сонгоно уу." });
            return false;
        }
        // Banner
        if (!this.state.imageObjs.lg.file && !this.state.model.imageLgUrl) {
            this.setState({ errorMsg: "Том хэмжээтэй зураг оруулна уу" });
            return false;
        }
        if (!this.state.imageObjs.sm.file && !this.state.model.imageSmUrl) {
            this.setState({ errorMsg: "Дунд хэмжээтэй зураг оруулна уу" });
            return false;
        }

        if (this.state.model.id !== undefined) {
            if (this.state.model.name === this.originalModel.name
                && this.state.model.type === this.originalModel.type
                && this.state.model.info === this.originalModel.info
                && this.state.imageObjs.lg.name === this.originalModel.imageLgUrl
                && this.state.imageObjs.sm.name === this.originalModel.imageSmUrl
                && this.state.imageObjs.xs.name === this.originalModel.imageXsUrl
                && this.state.model.url === this.originalModel.url
                && this.state.model.active === this.originalModel.active) {
                this.setState({ errorMsg: "Өөрчлөлт байхгүй байна" });
                return false;
            }
        }
        this.setState({ errorMsg: "" });
        return true;
    }

    render() {
        if (this.state.redirect) {
            return <Redirect to={this.state.redirect}/>
        }
        return (
            <Container>
                <Dimmer active={this.state.loading} inverted>
                    <Loader size='medium'></Loader>
                </Dimmer>
                <h2>{!this.state.editing ? 'Шинэ' : ''} Баннер</h2>
                <Form widths='equal'>
                    <Form.Group>
                        {this.state.successMsg ? <div className="success-msg">{this.state.successMsg}</div> : null}
                        {this.state.errorMsg ? <div className="error-msg">{this.state.errorMsg}</div> : null}
                    </Form.Group>
                    <Form.Group widths='equal'>
                        <Form.Field required label='Нэр' control='input' value={this.state.model.name} onChange={this.onNameChange} />
                    </Form.Group>
                    <Form.Group widths='equal'>
                        <Form.Field label='URL' control='input' value={this.state.model.url} onChange={this.onUrlChange} />
                    </Form.Group>
                    <Form.Group>
                        <Form.TextArea label='Тайлбар' value={this.state.model.info} onChange={this.onInfoChange} />
                    </Form.Group>
                    <Form.Group className="flex-space-between">
                        <div className="field">
                            <label>Том хэмжээтэй зураг (4:1)</label>
                        </div>
                        <div className={this.state.imageObjs.lg.uploaded && this.state.imageObjs.lg.showOriginal ? "flex-space-between" : "hidden-div"}>
                            <ImageOnS3 imgKey={this.state.model.imageLgUrl} width='160px' height='40px'/>
                            <Icon className="cursor margin-10" name="trash" size='large' onClick={() => this.toggleImage('imageLgUrl')} />
                        </div>
                        <Icon className={this.state.imageObjs.lg.uploaded && !this.state.imageObjs.lg.showOriginal ? "" : "hidden-div"} name='redo' size='large' onClick={() => this.toggleImage('imageLgUrl')}/>
                        <Form.Input control='input' type="file" accept="image/png, image/jpeg" onChange={this.handleImageLgChange} />
                    </Form.Group>
                    <Form.Group className="flex-space-between">
                        <div className="field">
                            <label>Дунд хэмжээтэй зураг 1000x250 pixel (4:1)</label>
                        </div>
                        <div className={this.state.imageObjs.sm.uploaded && this.state.imageObjs.sm.showOriginal ? "flex-space-between" : "hidden-div"}>
                            <ImageOnS3 imgKey={this.state.model.imageSmUrl} width='160px' height='40px'/>
                            <Icon className="cursor margin-10" name="trash" size='large' onClick={() => this.toggleImage('imageSmUrl')} />
                        </div>
                        <Icon className={this.state.imageObjs.sm.uploaded && !this.state.imageObjs.sm.showOriginal ? "" : "hidden-div"} name='redo' size='large' onClick={() => this.toggleImage('imageSmUrl')}/>
                        <Form.Field control='input' type="file" accept="image/png, image/jpeg" onChange={this.handleImageSmChange} />
                    </Form.Group>
                    <Form.Group className="flex-space-between">
                        <div className="field">
                            <label>Жижиг хэмжээтэй зураг (600 x 500 pixel)</label>
                        </div>
                        <div className={this.state.imageObjs.xs.uploaded && this.state.imageObjs.xs.showOriginal ? "flex-space-between" : "hidden-div"}>
                            <ImageOnS3 imgKey={this.state.model.imageXsUrl} width="150px" height="45px"/>
                            <Icon className="cursor margin-10" name="trash" size='large' onClick={() => this.toggleImage('imageXsUrl')} />
                        </div>
                        <Icon className={this.state.imageObjs.xs.uploaded && !this.state.imageObjs.xs.showOriginal ? "" : "hidden-div"} name='redo' size='large' onClick={() => this.toggleImage('imageXsUrl')}/>
                        <Form.Field control='input' type="file" accept="image/png, image/jpeg" onChange={this.handleImageXsChange} />
                    </Form.Group>
                    <Form.Group>
                        <Form.Checkbox checked={this.state.model.active} onChange={this.onActiveChange} label='Идэвхитэй' />
                    </Form.Group>
                    <br />
                    <Form.Button disabled={this.state.loading} onClick={() => this.save()}>Хадгалах</Form.Button>
                </Form>
            </Container >
        );
    }
}

export default BannerForm;